




import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class TypeIcon extends Vue {
  @Prop({ required: false, type: String }) icon: string
}
